import { ArrowLeft } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './BackBar.module.scss';

const BackBar = ({ label, title, badge, onBack }) => (
  <button type="button" className={styles.backBar} onClick={onBack}>
    <ArrowLeft size={14} className={styles.arrow} aria-hidden="true" />
    <span className={styles.body}>
      <span className={styles.label}>{label}</span>
      <span className={styles.title}>{title}</span>
    </span>
    {badge}
  </button>
);

BackBar.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.node,
  badge: PropTypes.node,
  onBack: PropTypes.func.isRequired,
};

export default BackBar;
